<template lang="pug">
v-expansion-panel(
  :disabled="disabled"
).panel.pa-4.rounded-16.redesign-box-shadow.redesignBlack--text.font-weight-regular.overflow-hidden
  v-expansion-panel-header(
    :hide-actions="!value"
    v-slot="{ open }"
  ).pa-0.align-items-center.text-body-1
    .d-flex.flex-column.gap-8
      span.text-h6.font-weight-medium {{ title }}
      span.redesignSecondary--text {{ value || 'Не указано' }}
    template(v-if="panelAction && !open")
      app-button(
        :color="panelAction.color"
        rounded
        text
        @click="onActionClick"
      ).ml-auto.mr-1.max-width-fit-content
        template(v-if="panelAction.icon")
          v-icon(
            :size="24"
            left
          ) {{ panelAction.icon }}
        span {{ panelAction.title }}

  v-expansion-panel-content.mt-4
    slot
</template>

<script>
import { ROW_ACTION_KEY, ROW_ACTION } from '../constants';

export default {
  name: 'PanelBase',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    /**
     *  'indicate' | 'change' | 'link' | 'unlink' | 'upload' | 'confirm' | 'date' | 'reset';
     */
    actionType: {
      type: String,
      default: '',
    },
    noReset: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    panelAction() {
      if (!this.actionType || this.disabled) {
        return null;
      }

      const { reset } = ROW_ACTION_KEY;

      if (!this.value) {
        return {
          type: this.actionType,
          ...ROW_ACTION[this.actionType],
        };
      }

      if (!this.noReset) {
        return {
          type: reset,
          ...ROW_ACTION[reset],
        };
      }

      return null;
    },
  },
  watch: {},
  created() {},
  methods: {
    onActionClick(e) {
      if (this.value) {
        e.stopPropagation();
      }

      this.$emit(`click:${this.panelAction.type}`);
    },
  },
};
</script>

<style scoped lang="scss">
.panel {
  &::after {
    border-color: transparent !important;
  }
}

::v-deep .v-expansion-panel-content {
  &__wrap {
    padding: 0;
  }
}

::v-deep .list {
  margin-top: 8px;
  max-height: 390px;
  overflow-y: auto;
}
</style>
